<template>
  <div>
    <ProtocoloSearchForm
      :options="options"
      @filterProtocolos="filterProtocolos"
      @clearFilterProtocolos="clearFilterProtocolos"
      @novoProtocolo="modalProtocolo.show = true" />

    <div class="mt-4 border-top border-dark pt-3 d-flex justify-content-end">
      <button class="btn  btn-secondary btn-print mt-auto"
              @click="goToPrint()">
        <icon-svg icon="print"
                  class="icon-print icon--xs icons--secondary mr-1"
                  style="fill: white;" />
        Imprimir
      </button>
    </div>

    <div class="row">
      <div class="col"
           style="overflow: auto;">
        <hr>
        <b-table :fields="table.fields"
                 :items="protocolos"
                 outlined
                 :busy="table.busy"
                 class="text-center"
                 thead-class="Protocolos_table--header"
                 tbody-tr-class="thead-row-class Protocolos_table--row"
                 show-empty
                 @row-clicked="(protocolo) => goToProtocoloLogs(protocolo)">
          <template #table-busy>
            <div class="text-center text-info my-2">
              <b-spinner class="align-middle mr-2 icon--sm" />

              <strong>Carregando...</strong>
            </div>
          </template>
          <template slot="key_numero_ano"
                    slot-scope="data">
            {{ data.item.numero }}/{{ data.item.ano }}
          </template>
          <template slot="key_requerente"
                    slot-scope="data">
            <div class="text-left pl-5"
                 style="width: 260px;">
              {{ data.item.partes[0].nome }}
            </div>
          </template>
          <template slot="key_natureza"
                    slot-scope="data">
            <div class="text-left pl-5">
              <div style="width: 200px;">
                {{ data.item.natureza }}
              </div>
            </div>
          </template>
          <template v-slot:empty="scope">
            <div class="text-center">
              Sem registros
            </div>
          </template>
          <template slot="key_inicial_final"
                    slot-scope="data">
            <div class="text-center">
              {{ data.item.prefixo_inicial }}{{ data.item.numero_inicial }} - {{ data.item.prefixo_final }}{{ data.item.numero_final }}
            </div>
          </template>
          <template slot="key_data_protocolo"
                    slot-scope="data">
            <div class="text-center"
                 style="width: 100px">
              {{ data.item.data_protocolo | date }}
            </div>
          </template>
          <template slot="key_status"
                    slot-scope="data">
            <div class="text-center">
              {{ getStatus(data.item.status) }}
            </div>
          </template>
          <template slot="key_acoes"
                    slot-scope="data">
            <div class="text-center col-1">
              <b-dropdown v-b-tooltip.hover
                          class="mx-1"
                          right
                          text=""
                          title="Ações">
                <b-dropdown-item v-if="data.item.status == 'EM_ANDAMENTO'"
                                 @click="cumprirProtocolo(data.item)">
                  Cumprir
                </b-dropdown-item>
                <b-dropdown-item @click="() => {modalDetalhes.protocolo = data.item; modalDetalhes.show = true}">
                  Detalhes
                </b-dropdown-item>
                <b-dropdown-item v-if="data.item.status == 'CUMPRIDO' || data.item.status == 'EM_ANDAMENTO'"
                                 @click="cancelarProtocolo(data.item)">
                  Cancelar
                </b-dropdown-item>
                <b-dropdown-item v-if="data.item.status == 'CUMPRIDO' || data.item.status == 'CANCELADO'"
                                 @click="reverterProtocolo(data.item)">
                  Reverter
                </b-dropdown-item>
                <b-dropdown-item v-if="data.item.status == 'EM_ANDAMENTO'"
                                 @click="deleteProtocolo(data.item)">
                  Excluir
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </template>
        </b-table>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <Pagination v-if="protocolos.length > 0"
                    :page="pagination.page"
                    :last-page="pagination.lastPage"
                    :select-page="true"
                    @onPreviousPage="changePage(pagination.page - 1)"
                    @onNextPage="changePage(pagination.page + 1)"
                    @onSetPage="page => changePage(page)" />
      </div>
    </div>

    <!-- protocolo form -->
    <protocolo-form v-if="modalProtocolo.show"
                    :prop-naturezas="options.naturezas"
                    :prop-protocolo="modalProtocolo.protocolo"
                    @onSaveProtocolo="(protocolo) => saveProtocolo(protocolo)"
                    @onCloseModal="closeModalProtocolo()" />

    <!-- modal cumprir / cancelar -->
    <protocolo-acoes v-if="modalAcoes.show"
                     :prop-tipo="modalAcoes.tipo"
                     :prop-protocolo="modalAcoes.protocolo"
                     @onCancelarProtocolo="(protocolo) => {modalDetalhes.protocolo = protocolo; modalDetalhes.show = true}"
                     @onClose="closeModalAcoes"
                     @onReload="reloadModalAcoes" />
    <ProtocoloDetalhes :show="modalDetalhes.show"
                       :prop-protocolo="modalDetalhes.protocolo"
                       @onCancelProtocolo="cancelarProtocolo"
                       @onEdit="onEdit"
                       @close="() => {modalDetalhes.show = false; modalDetalhes.protocolo = null}" />
  </div>
</template>

<script>
  /* services */
  import ProtocolosService from "@/services/Protocolos"
  import HabilitacaoService from "@/services/Registros/Habilitacao"
  import NaturezaProtocoloService from "@/services/NaturezaProtocoloService"

  /* components */
  import Pagination from '@/components/SofiaRei/Pagination'
  import ProtocoloForm from "@/components/SofiaRei/Protocolos/ProtocoloForm"
  import ProtocoloAcoes from "@/components/SofiaRei/Protocolos/ProtocoloAcoes"
  import ProtocoloSearchForm from "@/views/SofiaRei/Protocolos/ProtocoloSearchForm.vue"
  import ProtocoloDetalhes from "./ProtocoloDetalhes/ProtocoloDetalhes.vue"
  

  /* libraries */
  import moment from "moment"

  export default {
    name: "ProtocolosLista",
    components: {
      Pagination,
      ProtocoloForm,
      ProtocoloAcoes,
      ProtocoloSearchForm,
      ProtocoloDetalhes
    },
    data () {
      return {
        modalAcoes: {
          show: false,
          tipo: null,
          protocolo: {}
        },
        modalProtocolo: {
          show: false,
          protocolo: {}
        },
        modalDetalhes: {
          show: false,
          protocolo: {}
        },
        pagination: {
          page: 1,
          perPage: 10,
          lastPage: null
        },
        table: {
          busy: false,
          fields: [
            {
              key: 'key_numero_ano',
              label: 'Protocolo/Ano',
              sortable: false
            },
            {
              key: 'key_data_protocolo',
              label: 'Dt. protocolo',
              sortable: false
            },
            {
              key: 'key_requerente',
              label: 'Requerente',
              sortable: false
            },
            {
              key: 'key_status',
              label: 'Status',
              sortable: false
            },
            {
              key: 'key_natureza',
              label: 'Natureza',
              sortable: false
            },
            {
              key: 'key_status',
              label: 'Status',
              sortable: false
            },
            {
              key: 'key_acoes',
              label: 'Ação',
              sortable: false
            }
          ]
        },
        search: {
          numero: null,
          ano: moment(new Date()).format('YYYY'),
          status: null,
          natureza: null,
          data_inicial: '',
          data_final: '',
          matricula: null
        },
        protocolos: [],
        options: {
          naturezas: [],
          anos: [],
          status: [
            { value: 'EM_ANDAMENTO', label: 'Em andamento' },
            { value: 'CUMPRIDO', label: 'Cumprido' },
            { value: 'CANCELADO', label: 'Cancelado' }
          ]
        }
      }
    },
    created () {
      this.init()
    },
    methods: {
      async init () {
        try {
          await this.getNaturezaProtocolos()
          // verifica se existe parametro na rota
          const { page } = this.$route.query
          if (page) {
            this.pagination.page = +page
          }
          this.getUltimosDezAnos()

          await this.filterProtocolos(this.search)
        } catch (e) {
          console.error(e)
        }
      },
      async getNaturezaProtocolos () {
        let naturezas = await NaturezaProtocoloService.index()

        naturezas = naturezas
          .filter((natureza) => {
            return natureza.ativo
          })
          .map((natureza) => {
            return natureza.descricao
          })

        this.options.naturezas = naturezas
      },
      goToProtocoloLogs (protocolo) {
        this.modalDetalhes.protocolo = protocolo
        this.modalDetalhes.show = true
        // this.$router.push({
        //   name: 'protocolos_detalhes',
        //   params: {
        //     id: protocolo.id,
        //     propProtocolo: protocolo
        //   }
        // })
      },
      getStatus (status) {
        const obj = {
          'EM_ANDAMENTO': 'Em andamento',
          'CUMPRIDO': 'Cumprido',
          'CANCELADO': 'Cancelado'
        }

        return obj[status]
      },
      async deleteProtocolo (protocolo) {
        try {
          if (!protocolo.registro) {
            objSwal.question.title = `Atenção!`
            objSwal.question.text = `Deseja excluir o protocolo ${ protocolo.numero }?`
          } else {
            objSwal.question.title = `Atenção: Protocolo vinculado!`
            objSwal.question.html = `${ this.getUrl(protocolo) } tem a mesma matrícula que foi informada no protocolo.<br><br>
Ainda deseja excluir o protocolo ${ protocolo.numero }/${ protocolo.ano }?`
          }

          const status = await Swal.fire(objSwal.question)
          objSwal.question.text = ''
          objSwal.question.html = ''

          // confirme a exclusão
          if (status.value) {
            loader({ active: true, text: 'Excluindo protocolo...' })
            await ProtocolosService.delete(protocolo.id)

            // só casamento tem vinculo direto hj com o protocolo_automatico
            // então verificamos só ele
            if (protocolo.registro && protocolo.registro.habilitacaoCasamento) {
              await HabilitacaoService.updateProtocoloAutomatico({ protocolo_automatico: false }, protocolo.registro.habilitacaoCasamento.habilitacao_casamento_id)
            }

            objSwal.success.title = 'Protocolo excluido!'
            Swal.fire(objSwal.success)
            this.init()
          }
        } finally {
          loader({ active: false, text: '' })
        }
      },
      closeModalProtocolo () {
        this.modalProtocolo.show = false
        this.modalProtocolo.protocolo = {}
      },
      async saveProtocolo (protocolo) {
        try {
          loader({ active: true, text: 'Salvando protocolo...' })
          if (!protocolo.id) {
            const protocoloSave = await ProtocolosService.store(protocolo)

            if (protocoloSave.success) {
              objSwal.success.title = `Protocolo "${ protocoloSave.protocolo.numero }/${ protocoloSave.protocolo.ano }" gerado!`
              Swal.fire(objSwal.success)
              this.closeModalProtocolo()
              this.init()
            } else {
              throw 'Houve um erro no cadastro de protocolo.'
            }
          } else {
            const editProtocolo = await ProtocolosService.update(protocolo.id, protocolo)
      
            objSwal.success.title = `Protocolo "${ editProtocolo.numero }/${ editProtocolo.ano }" atializado!`
            Swal.fire(objSwal.success)
            this.closeModalProtocolo()            
            this.init()
   
          }

        } catch (e) {
          objSwal.error.title = 'Erro!'

          if (e.response.data &&  e.response.data.message) {
            if (e.response.data.message.match(/.*protocolo_usuario_id_numero_ano_unique.*/)) {
              const duplicate = e.response.data.message.match(/Duplicate entry (.*)/)[1]
              const numero = duplicate.split(' ')[0].replace(/'/g,'').split('-')
              objSwal.error.text = `Já existe um protocolo com o número ${ numero[1] } para o ano ${ numero[2] }`
            } else if (e.response.data.message.match(/.*Nenhum protocolo configurado para o ano .*/)) {
              const bkpQuestion = { ...objSwal.question }

              objSwal.question.title = 'Atenção!'
              objSwal.question.text = e.response.data.message
              objSwal.question.cancelButtonText = 'Fechar'
              objSwal.question.confirmButtonText = 'Ir para página de configuração'
              const statusQuestion = await Swal.fire(objSwal.question)

              // caso ele queira ir para pagina de configuração redirecionamos
              if (statusQuestion.value) {
                let routeData = this.$router.resolve({name: 'cadastro_serventia', query: { acao: "protocolo" }})
                window.open(routeData.href, '_blank')
              }
              objSwal.question = { ...bkpQuestion }
              return
            } else {
              objSwal.error.text = (e.response.data &&  e.response.data.message)
            }
          } else {
            objSwal.error.text = 'Houve um erro ao editar o protocolo, tente novamente.'
          }
          Swal.fire(objSwal.error)
          console.error(e)
        } finally {
          loader({ active: false, text: '' })
        }
      },
      cumprirProtocolo (protocolo) {
        this.modalAcoes.tipo = 'cumprir'
        this.modalAcoes.protocolo = protocolo
        this.modalAcoes.show = true
      },
      cancelarProtocolo (protocolo) {
        this.modalAcoes.tipo = 'cancelar'
        this.modalAcoes.protocolo = protocolo
        this.modalAcoes.show = true
      },
      closeModalAcoes () {
        this.modalAcoes.tipo = null
        this.modalAcoes.protocolo = {}
        this.modalAcoes.show = false
      },
      reloadModalAcoes () {
        this.closeModalAcoes()
        this.init()
      },
      getUltimosDezAnos () {
        const anoAtual = moment().year()
        let ultimosDezAnos = []
        for (let i = 0; i < 10; i++) {
          ultimosDezAnos.push({ano: anoAtual - i})
        }
        this.options.anos = ultimosDezAnos
      },
      async filterProtocolos (search) {
        this.search = search
        this.table.busy = true
 
        const response = await ProtocolosService.index({ ...search, ...this.pagination })
        if (!search) this.options.anos = await ProtocolosService.anosUsados()
        this.protocolos = response.data
        this.pagination.lastPage = response.lastPage
        this.pagination.total = response.total
        this.table.busy = false
 
      },
      clearFilterProtocolos (search) {
        this.search = search
        this.init()
      },
      async reverterProtocolo (protocolo) {
        objSwal.question.title = 'Atenção'
        objSwal.question.text = 'O protocolo irá voltar para o status "Em andamento", deseja continuar?'
        const status = await Swal.fire(objSwal.question)

        if (status.value) {
          try {
            loader({ active: true, text: 'Descumprindo protocolo...' })
            await ProtocolosService.reverter(protocolo)
            objSwal.success.title = 'Protocolo descumprido!'
            Swal.fire(objSwal.success)
            this.init()
          } finally {
            loader({ active: false, text: '' })
          }
        }
      },
      changePage (page) {
        this.$router.push({
          name: 'protocolos',
          query: {
            page
          }
        })
        this.init(true)
      },
      getUrl (protocolo) {
        let url = null
        const tipoRegistro = {
          CR: 'Casamento',
          C: 'Casamento',
          D: 'Habilitação de casamento',
          O: 'Óbito',
          N: 'Nascimento',
          NT: 'Nascimento'
        }

        switch (protocolo.registro.tipo_registro) {
        case 'C': case 'CR':
          url = { name: 'resumo_casamento', params: { id: protocolo.registro.casamento.casamento_id } }
          break
        case 'D':
          url = { name: 'resumo_habilitacao_casamento', params: { id: protocolo.registro.habilitacaoCasamento.habilitacao_casamento_id } }
          break
        case 'O': case 'NT':
          url = { name: 'resumo_obito', params: { id: protocolo.registro.obito.obito_id } }
          break
        case 'N':
          url = { name: 'resumo_nascimento', params: { id: protocolo.registro.nascimento.nascimento_id } }
          break
        }

        const routeData = this.$router.resolve(url)
        return `<a href="${ routeData.href }" target="_blank">${ tipoRegistro[protocolo.registro.tipo_registro] } #${ routeData.location.params.id }</a>`
      },
      goToPrint () {
        this.$router.push({
          name: 'protocolos_imprimir',
          params: {
            previousSearch: this.search,
            pushed: true
          }
        })
      },
      onEdit (protocolo) {
        this.modalDetalhes.show = false
        this.modalProtocolo.protocolo = protocolo
        this.modalProtocolo.show = true
        
      }
    }
  }
</script>

<style scoped>


  .btn-print:hover > [class*=icon-print] {
    fill: #fff !important;
  }

  .btn-novo-protocolo {
    position: absolute;
    right: 75px;
    top: 100px;
  }
</style>
